export default __webpack_public_path__ + "static/media/blogsIcon.f1fb526a.svg";